(function () {
  document.querySelectorAll('[data-collection-product-tabs]').forEach((root) => {
    const buttons = Array.from(root.querySelectorAll('[data-collection-product-tab]'));
    const panel = root.querySelector('[data-collection-product-panel]');

    const activate = (button, moveFocus) => {
      const target = button.getAttribute('data-collection-product-tab');
      root.setAttribute('data-active-tab', target);

      buttons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      if (panel && button.id) panel.setAttribute('aria-labelledby', button.id);
      if (moveFocus) button.focus();
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button, false));

      button.addEventListener('keydown', (event) => {
        let next = null;
        switch (event.key) {
          case 'ArrowRight':
            next = buttons[(index + 1) % buttons.length];
            break;
          case 'ArrowLeft':
            next = buttons[(index - 1 + buttons.length) % buttons.length];
            break;
          case 'Home':
            next = buttons[0];
            break;
          case 'End':
            next = buttons[buttons.length - 1];
            break;
          default:
            return;
        }
        event.preventDefault();
        activate(next, true);
      });
    });

    // Card click to navigate
    root.querySelectorAll('.collection-tab-product-card').forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        const url = card.getAttribute('data-product-url');
        if (url) window.location.href = url;
      });
    });
  });
})();
